/* eslint-disable import/no-cycle */
/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';
import api from '../../utils/api';
import { success, fail } from '../../utils/toast';

const options = {
	persist: true
};

Vue.use(Vuex);
Vue.use(VueSession, options);

const state = {
	referrals: [],
	totalReferrals: '',
	referralDetail: {}
};

const getters = {
	getReferrals: (state) => state.referrals,
	getTotalReferrals: (state) => state.totalReferrals,
	getReferralDetail: (state) => state.referralDetail
};

const mutations = {
	setReferrals: (state, data) => {
		state.referrals = data;
	},

	setTotal: (state, data) => {
		state.totalReferrals = data;
	},

	setUpdateReferral: (state, data) => {
		state.referralDetail = { ...state.referralDetail, ...data };
	}
};

const actions = {
	fetchAllReferrals: ({ commit }, data) => {
		const [limit, offset] = [...data];
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		api.get(`/users/referral?limit=${limit}&offset=${offset}`)
			.then((response) => {
				if (response.status === 200) {
					commit('setReferrals', response.data.data);
					commit('setTotal', response.data.total);
					commit('reqSuccess', null, { root: true });
					return true;
				}
				commit('reqError', null, { root: true });
				return false;
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				commit(
					'logError',
					{
						type: 'fetch-referrals',
						...(error.response.data || 'Error Fetching Referrals, Please Try Again.')
					},
					{ root: true }
				);
				bugsnagClient.notify(error);
				return error;
			});
		return true;
	},

	updateReferral: ({ commit }, data) => {
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		const { id, is_paid: isPaid } = { ...data };
		api.patch(`users/referral/${id}`, { is_paid: isPaid })
			.then((response) => {
				if (response.status === 200) {
					commit('setUpdateReferral', response.data);
					commit('updateSuccess');
					commit('reqSuccess', null, { root: true });
					success({
						title: 'Success',
						text: 'Referral status has been updated!'
					});
					return true;
				}
				commit('reqError', null, { root: true });
				fail({
					title: 'Error',
					text: 'Oops! Something went wrong'
				});
				return false;
			})
			.catch((error) => {
				commit('reqError', null, { root: true });
				commit('logError', { ...error.response.data, type: 'updateReferral' }, { root: true });
				bugsnagClient.notify(error);
				return error;
			})
			.finally(() => {
				commit('resetUpdate');
			});
		return true;
	}
};

export default {
	state,
	actions,
	getters,
	mutations
};
